/*
 * @Author: Chao Yang
 * @Date: 2020-09-08 15:33:01
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-09 10:59:14
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OnboardingProxy } from 'src/app/domain/proxy/offering/onboarding.proxy';
import * as Onboarding from 'src/app/domain/model/offering';

@Injectable()
export class OnboardingService {
  constructor(private onboardingProxy: OnboardingProxy) {}

  getFundListByMarketingFundId(
    fundId: number
  ): Observable<Onboarding.IMarketingFund> {
    return this.onboardingProxy.getFundListByMarketingFundId(fundId).pipe(
      map((fund) => {
        fund.dropDownFunds = [];
        fund.funds.forEach((f) => {
          fund.dropDownFunds.push({
            text: f.fundName,
            value: f.onboardingFundId,
            accounts: f.existingAccounts,
          });
        });
        return fund;
      })
    );
  }

  checkAccountNameUnique(
    onboardingFundId: number,
    name: string
  ): Observable<boolean> {
    return this.onboardingProxy.checkAccountNameUnique(onboardingFundId, name);
  }

  subscribeToOnboarding(
    onboardingFundId: number,
    name: string
  ): Observable<Onboarding.ISubscribeResult> {
    return this.onboardingProxy.subscribeToOnboarding(onboardingFundId, name);
  }
}
